import { configureStore } from '@reduxjs/toolkit'

import { middleware } from './middleware'
// import { actions as orderActions } from './orderSlice'
import { reducer } from './reducer'

export const store = configureStore({
  reducer,
  middleware: gDM => [...gDM(), ...middleware],
})
